import Skeleton from 'react-loading-skeleton';
import MarketingEditSkeletons, {
  MARKETING_EDIT_SKELETONS,
} from '~/view/screens/MarketingScreen/components/MarketingEditSkeletons/MarketingEditSkeletons';
import './style.scss';

const PromobannerEditLoader = (): JSX.Element | null => {
  return (
    <>
      <Skeleton className="promobanner-skeleton-upload" width="100%" />
      <MarketingEditSkeletons type={MARKETING_EDIT_SKELETONS.PROMOBANNER} />
    </>
  );
};

export default PromobannerEditLoader;
